// CC_TELEFONE_CLICAVEL (2026-09-30, pedido do usuario: "numero nao ta clicavel e nao abre o chat do numero"):
// depois que o texto da mensagem aparece, marca os numeros de telefone como link. Clicando: acha o
// contato (com e sem o 9), cria se nao existir, reaproveita a conversa aberta ou abre uma nova no mesmo
// canal do ticket atual e leva direto pra ela. Numeros com menos de 10 ou mais de 13 digitos nao viram link.
import React, { useContext, useEffect, useRef } from "react";
import WhatsMarked from "react-whatsmarked";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const PHONE_RE = /(\+?\d[\d\s().-]{8,20}\d)/g;

const normaliza = (txt) => {
  const d = String(txt).replace(/\D/g, "");
  if (d.length < 10 || d.length > 13) return null;
  if (d.length <= 11) return "55" + d;
  return d.startsWith("55") ? d : null;
};
const variantes = (d) => {
  const v = [d];
  if (d.length === 13 && d[4] === "9") v.push(d.slice(0, 4) + d.slice(5));
  if (d.length === 12) v.push(d.slice(0, 4) + "9" + d.slice(4));
  return v;
};

export default function PhoneLinkBody({ ticketId, sx, children }) {
  const ref = useRef(null);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) {
      if (n.parentElement && n.parentElement.closest("a,[data-cc-phone]")) continue;
      PHONE_RE.lastIndex = 0;
      if (PHONE_RE.test(n.nodeValue)) nodes.push(n);
    }
    nodes.forEach((node) => {
      const txt = node.nodeValue;
      const frag = document.createDocumentFragment();
      let last = 0;
      let m;
      PHONE_RE.lastIndex = 0;
      while ((m = PHONE_RE.exec(txt))) {
        const d = normaliza(m[1]);
        if (!d) continue;
        frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
        const a = document.createElement("a");
        a.textContent = m[1];
        a.href = "#";
        a.setAttribute("data-cc-phone", d);
        a.title = "Abrir conversa com este número";
        a.style.cursor = "pointer";
        frag.appendChild(a);
        last = m.index + m[1].length;
      }
      if (last === 0 || !node.parentNode) return;
      frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  });

  const abrir = async (d) => {
    try {
      let contact = null;
      for (const v of variantes(d)) {
        const { data } = await api.get("contacts", { params: { searchParam: v } });
        contact = (data.contacts || []).find((c) => String(c.number).replace(/\D/g, "") === v);
        if (contact) break;
      }
      if (!contact) {
        const { data } = await api.post("/contacts", { name: "+" + d, number: d });
        contact = data;
      }
      const { data: aberto } = await api.get(`/tickets/contact/${contact.id}/open`);
      if (aberto && aberto.hasOpenTicket && aberto.ticket) {
        navigate(`/tickets/${aberto.ticket.id}`);
        return;
      }
      let whatsappId;
      try {
        const { data: t } = await api.get(`/tickets/${ticketId}`);
        whatsappId = t.whatsappId;
      } catch (e) {}
      const { data: ticket } = await api.post("/tickets", { contactId: contact.id, userId: user?.id, status: "open", whatsappId });
      localStorage.setItem("pressticket:changeTab", "open");
      navigate(`/tickets/${ticket.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const onClick = (e) => {
    const a = e.target && e.target.closest ? e.target.closest("[data-cc-phone]") : null;
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    abrir(a.getAttribute("data-cc-phone"));
  };

  return (
    <span ref={ref} onClick={onClick} style={{ display: "contents" }}>
      <WhatsMarked sx={sx}>{children}</WhatsMarked>
    </span>
  );
}
